/* eslint-disable no-console */
import _ from 'underscore';
import * as LocationUtils from './modules/location-utils';
import { getItemsFromAccount, removeItemFromAccount, saveItemToAccount } from './modules/consumer-account/storage-actions';

// console.log('\n\n\n*************************\n\nwhere-to-buy.js ver: 1.1.14 \n\n*************************\n\n\n');

const dealerGridDiv = document.getElementById('dealerGrid');
const searchBtn = document.querySelector('.map-search-button');
const jsApiKey = 'AIzaSyC4sfbAE6e5UIgaioDzFRFhN-T-HS4YxhM';
const labels = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
const mapDiv = document.getElementById('locatorMap');
const mapInit = window.locatorMap;
const maxMarkers = 10;
const noContentDiv = document.getElementById('locatorMapNoContent');
const requestUrl = window.getLocationsPath;
const savedDealerData = [];
const noSavedDealerClass = 'no-saved-expert';
const { isAuthenticatedDealer } = window;

_.templateSettings = {
  interpolate: /\{\{(.+?)\}\}/g,
};

const dealerCardTemplate =
  `<div class="dealer-card">
    <div class="dealer-card--banner">
      <div class="dealer-card--letter">{{ label }}</div>
    </div>
    <div class="dealer-card--content">
      <div class="dealer-card--name">{{ businessname }}</div>
      <div class="dealer-card--contact">
        {{ distance }} mi<br />
        <a class="phone-link" href="tel:{{ phonenumber }}">{{ phonenumber }}</a><br />
        <a href="mailto:{{ email }}">Email</a>
      </div>
    </div>
    <button class="savebutton{{ hideFavorites }}" data-record-id="{{ recordid }}" data-dealer-name="{{ businessname }}">
      <span>
        <div class="savebutton--icon">
          <div class="icon"></div>
        </div>
        <div class="savebutton--label">Save<span class="sr-only"> {{ businessname }}</span> to My Favorites</div>
      </span>
    </button>
  </div>`;

const savedDealerCardTemplate =
  `<div class="dealer-card">
    <div class="dealer-card--banner">
      <div class="dealer-card--heading">My Dealer</div>
    </div>
    <div class="dealer-card--content">
      <div class="dealer-card--name">{{ businessname }}</div>
      <div class="dealer-card--contact">
        <a class="phone-link" href="tel:{{ phonenumber }}">{{ phonenumber }}</a><br />
        <a href="mailto:{{ email }}">Email</a>
      </div>
    </div>
    <button class="savebutton is-active">
      <span>
        <div class="savebutton--icon">
          <div class="icon"></div>
        </div>
        <div class="savebutton--label"><span class="sr-only">Remove </span>Saved<span class="sr-only"> Dealer</span></div>
      </span>
    </button>
  </div>`;

const dealerInfoWindowTemplate =
  `<div class="dealer-card info-window-card">
    <div class="dealer-card--content">
      <div class="dealer-card--name">{{ businessname }}</div>
      <div class="dealer-card--contact">
        {{ distance }} mi<br />
        <a class="phone-link" href="tel:{{ phonenumber }}">{{ phonenumber }}</a><br />
        <a href="mailto:{{ email }}">Email</a>
      </div>
    </div>
  </div>`;

let activeMarker;
let bounds = null;
let mapLocations = [];
let map = null;
let markers = [];
let submitErrorText = '';
let userLocationData;

const dealerCardTemplateVals = _.template(dealerCardTemplate);
const savedDealerCardTemplateVals = _.template(savedDealerCardTemplate);
const dealerInfoWindowTemplateVals = _.template(dealerInfoWindowTemplate);

const getDealerDataByRecordId = id => (
  mapLocations.find(dealer => dealer.recordid === id)
);

const toggleDealerAccountStatus = (btn) => {
  // Remove .is-active from all buttons
  const btns = dealerGridDiv.querySelectorAll('.savebutton');
  const btnId = btn.getAttribute('data-record-id');
  const dealerName = btn.getAttribute('data-dealer-name');
  for (let i = 0; i < btns.length; i++) { /* eslint-disable-line no-plusplus */
    const recordid = btns[i].getAttribute('data-record-id');
    if (recordid !== btnId) {
      btns[i].classList.remove('is-active');
    }
  }
  // Evaluate specific button
  if (btn.classList.contains('is-active')) {
    btn.classList.remove('is-active');
    btn.querySelector('.savebutton--label').innerHTML = `Save<span class="sr-only"> ${dealerName}</span> to My Favorites`;
  } else {
    btn.classList.add('is-active');
    btn.querySelector('.savebutton--label').innerHTML = '<span class="sr-only">Remove </span>Saved<span class="sr-only"> Dealer</span>';
  }
};

const checkSavedDealerMatch = (recordid) => {
  if (savedDealerData.length === 0) {
    return false;
  }
  if (savedDealerData[0].recordid === recordid) {
    return true;
  }
  return false;
};

const removeDealerFromAccount = () => {
  const { assetId } = savedDealerData[0];
  removeItemFromAccount('location', assetId, () => {
    const selector = document.querySelector('.my-expert');
    const btn = selector.querySelector('.savebutton');
    if (btn !== null) {
      btn.removeEventListener('click', removeDealerFromAccount);
      selector.removeChild(selector.firstChild);
      // Remove existing dealer from savedDealerData array
      savedDealerData.splice(0, 1);
      // Update DOM
      selector.parentNode.classList.add(noSavedDealerClass);
      // Update card in .dealer-grid, if present
      const dealerCardBtn = dealerGridDiv.querySelector('.savebutton.is-active');
      if (dealerCardBtn !== null) {
        toggleDealerAccountStatus(dealerCardBtn);
      }
    }
  });
};

const onSavedDealerDataLoaded = (data) => {
  // console.log(data);
  if (data !== null) {
    savedDealerData.push(data);
    // Display saved content
    const selector = document.querySelector('.my-expert');
    const div = document.createElement('div');
    const compiled = savedDealerCardTemplateVals(savedDealerData[0]);
    selector.innerHTML = '';
    div.innerHTML = compiled;
    selector.parentNode.classList.remove(noSavedDealerClass);
    selector.appendChild(div.firstChild);
    selector.querySelector('.savebutton').addEventListener('click', removeDealerFromAccount);
  }
};

const addSaveDealerToAccountHandlers = () => {
  // If dealer, don't use template w/o save to favorites
  if (!isAuthenticatedDealer) {
    const btns = dealerGridDiv.querySelectorAll('.savebutton');
    for (let i = 0; i < btns.length; i++) { /* eslint-disable-line no-plusplus */
      const btn = btns[i];
      const recordid = btn.getAttribute('data-record-id');
      // Check to see if dealer card record-id matches saved dealer... if saved dealer exists
      // console.log(`${recordid}, ${checkSavedDealerMatch(recordid)}`);
      if (checkSavedDealerMatch(recordid)) {
        toggleDealerAccountStatus(btn);
      }
    }
    // Add eventlisteners for saving/removing dealer... outside for loop
    const saveBtns = document.querySelectorAll('.savebutton');
    [].map.call(saveBtns, btn => btn.addEventListener('click', () => {
      if (btn.classList.contains('is-active')) {
        // Remove
        removeDealerFromAccount();
      } else {
        // Save
        const recordid = btn.getAttribute('data-record-id');
        const dealerData = getDealerDataByRecordId(recordid);
        // console.log(dealerData);
        saveItemToAccount(
          'location',
          dealerData,
          (data) => {
            if (data.success) {
              // Remove existing dealer from savedDealerData array
              savedDealerData.splice(0, 1);
              toggleDealerAccountStatus(btn);
              // Add card next to map
              onSavedDealerDataLoaded({
                assetId: data['asset-id'],
                businessname: dealerData.businessname,
                distance: dealerData.distance,
                email: dealerData.email,
                phonenumber: dealerData.phonenumber,
                recordid: dealerData.accountnumber,
              });
            }
          },
        );
      }
    }));
  }
};

const disableSearchButton = () => {
  searchBtn.setAttribute('disabled', 'disabled');
  searchBtn.value = 'Searching...';
};

const enableSearchButton = () => {
  searchBtn.removeAttribute('disabled');
  searchBtn.value = 'Search Dealers';
};

const sortByDistance = (a, b) => {
  if (a.distance < b.distance) {
    return -1;
  }
  if (a.distance > b.distance) {
    return 1;
  }
  return 0;
};

const getValidAddress = (str) => {
  if (str === '') {
    return false;
  }
  return true;
};

const showMap = (bool) => {
  // Show map, hide initial message area
  if (bool) {
    mapDiv.classList.add('locator-map-expanded');
    noContentDiv.classList.add('hidden');
  } else {
    mapDiv.classList.remove('locator-map-expanded');
    noContentDiv.classList.remove('hidden');
  }
};

const initMap = () => {
  /* eslint-disable no-undef */
  bounds = new google.maps.LatLngBounds();
  map = new google.maps.Map(mapDiv, {
    center: new google.maps.LatLng(43.1162759, -89.5101693),
  });
  /* eslint-enable no-undef */
};

const appendMapScript = () => {
  const script = document.createElement('script');
  script.src = `https://maps.googleapis.com/maps/api/js?key=${jsApiKey}&callback=initMap`;
  document.body.appendChild(script);
};

const adjustZoomAfterBounds = () => {
  // Don't allow extreme zoom when there's (likely) only one result
  const listener = google.maps.event.addListener(map, 'idle', () => { /* eslint-disable-line no-undef */
    if (map.getZoom() > 13) {
      map.setZoom(13);
    }
    google.maps.event.removeListener(listener); /* eslint-disable-line no-undef */
  });
};

const updateLocations = () => {
  // Remove any map markers
  markers.forEach((item) => {
    item.setMap(null);
  });
  // Remove any cards in grid
  dealerGridDiv.innerHTML = '';
  // Reset bounds
  bounds = new google.maps.LatLngBounds(); /* eslint-disable-line no-undef */
  // Restrict number of locations to max or under (should always be equal to max)
  let len = maxMarkers;
  if (mapLocations.length < maxMarkers) {
    len = mapLocations.length;
  }
  // Add locations & markers
  let position;
  let icon;
  let marker;
  let infowindow;
  let div;
  let loc;
  let i = 0;
  do {
    loc = mapLocations[i];
    loc.label = labels.substr(i, 1);
    loc.hideFavorites = window.isAuthenticatedDealer ? ' hidden' : '';
    // Map accountnumber to recordid for matching
    loc.recordid = loc.accountnumber;
    position = new google.maps.LatLng(loc.latitude, loc.longitude); /* eslint-disable-line no-undef */

    icon = {
      url: `${window.imagePath}icon-marker.svg`,
      scaledSize: new google.maps.Size(36, 36), /* eslint-disable-line no-undef */
    };

    marker = new google.maps.Marker({ /* eslint-disable-line no-undef */
      position,
      animation: google.maps.Animation.DROP, /* eslint-disable-line no-undef */
      map,
      label: { text: loc.label, color: 'white' },
      icon,
    });

    marker.infowindowHtml = loc;

    infowindow = new google.maps.InfoWindow({ /* eslint-disable-line no-undef */
      content: '',
      maxWidth: 240,
    });

    markers.push(marker);
    map.fitBounds(bounds.extend(position));
    adjustZoomAfterBounds();
    // Add dealer cards to grid
    const compiled = dealerCardTemplateVals(loc);
    div = document.createElement('div');
    div.innerHTML = compiled;
    dealerGridDiv.appendChild(div.firstChild);
    i += 1;
  }
  while (i < len);

  addSaveDealerToAccountHandlers();

  markers.forEach(item => item.addListener('click', () => {
    // Reset active marker
    if (activeMarker !== undefined) {
      activeMarker.setIcon({
        url: `${window.imagePath}icon-marker.svg`,
        scaledSize: new google.maps.Size(36, 36), /* eslint-disable-line no-undef */
      });
    }
    // Set active marker
    item.setIcon({
      url: `${window.imagePath}icon-marker-active.svg`,
      scaledSize: new google.maps.Size(36, 36), /* eslint-disable-line no-undef */
    });
    infowindow.setContent(dealerInfoWindowTemplateVals(item.infowindowHtml));
    infowindow.open(map, item);
    // Set this as active item
    activeMarker = item;
  }));
};

const displayNoResultsMessage = () => {
  document.querySelector('.map-no-content').innerHTML = window.noResultsMessage;
  // Reset map state
  showMap(false);
  bounds = null;
  // Remove any existing markers
  markers.forEach((item) => {
    item.setMap(null);
  });
  markers = [];
  // Remove any cards in grid
  dealerGridDiv.innerHTML = '';
};

const formatLocationResults = (data) => {
  mapLocations = data.getlocationsresponse.locations.sort(sortByDistance);
  if (mapLocations.length === 0) {
    displayNoResultsMessage();
    return;
  }
  if (mapInit.init === true && map === null) {
    initMap();
  }
  showMap(true);
  updateLocations();
};

const requestLocationData = (latitude, longitude, radius, address) => {
  const postData = `brandcode=H&countrycode=US&latitude=${latitude}&longitude=${longitude}&address=${address}&radius=${radius}&results=10&netsales=0`;
  const request = new XMLHttpRequest();
  request.open('POST', requestUrl, true);
  request.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
  request.onload = () => {
    enableSearchButton();
    if (request.status >= 200 && request.status < 400) {
      const data = JSON.parse(request.responseText);
      formatLocationResults(data);
    }
  };
  request.onerror = () => {
    enableSearchButton();
    // const data = JSON.parse(request.responseText);
    // console.log(data);
    displayNoResultsMessage();
  };

  if (window.localTesting && window.locationData !== undefined) {
    request.onloadend = () => {
      enableSearchButton();
      formatLocationResults(window.locationData);
    };
  }
  request.send(postData);
};

const onSetLocationSuccess = (data) => {
  const radius = document.querySelector('#SelectRadius').value;
  // Wipe out anything in address field
  const addressIpt = document.querySelector('#AddressOrZipCode');
  addressIpt.value = '';
  userLocationData = data;
  requestLocationData(userLocationData.coords.lat, userLocationData.coords.lng, radius, addressIpt.value);
};

const locateDealers = () => {
  disableSearchButton();
  const addrDiv = document.querySelector('[for="AddressOrZipCode"]');
  const address = document.querySelector('#AddressOrZipCode').value;
  const radius = document.querySelector('#SelectRadius').value;
  const validOpt1 = getValidAddress(address) && radius !== '';
  const validOpt2 = userLocationData !== null && userLocationData !== undefined && radius !== '';
  const errorMessageDiv = document.querySelector('.dealer-locator .error-message');

  if (validOpt1 || validOpt2) {
    errorMessageDiv.classList.add('hidden');
    addrDiv.classList.remove('error');
    submitErrorText = '';
    LocationUtils.getAddressCoordinates(
      address,
      {
        success: (coords) => {
          requestLocationData(coords.lat, coords.lng, radius, address);
        },
        fail: () => {
          enableSearchButton();
          displayNoResultsMessage();
        },
      },
    );
    return;
  }

  if (!getValidAddress(address) && radius === '') {
    submitErrorText = 'Enter a valid address or zip code and select a radius';
  } else if (radius === '') {
    submitErrorText = 'Select a radius';
  } else if (!getValidAddress(address)) {
    submitErrorText = 'Enter a valid address or zip code';
    addrDiv.classList.add('error');
  }
  errorMessageDiv.innerHTML = submitErrorText;
  errorMessageDiv.classList.remove('hidden');
  enableSearchButton();
};

const onEnterKeyPress = (event) => {
  if (event.code === 'Enter') {
    locateDealers();
  }
};

const init = () => {
  appendMapScript();
  // Search button event handler
  searchBtn.addEventListener('click', () => {
    locateDealers();
  });
  // Add keypress event listener when address input has focus
  document.querySelector('#AddressOrZipCode').addEventListener('focus', () => {
    document.addEventListener('keypress', onEnterKeyPress);
  });
  document.querySelector('#AddressOrZipCode').addEventListener('blur', () => {
    document.removeEventListener('keypress', onEnterKeyPress);
  });
  // Use my location event handler
  document.querySelector('.use-my-location-button').addEventListener('click', () => {
    disableSearchButton();
    LocationUtils.getDeviceLocation({
      success: onSetLocationSuccess,
    });
  });
  // Check to see if a user has a dealer saved to their account
  const { isAuthenticated } = window;
  if (isAuthenticated) {
    getItemsFromAccount('location', (data) => {
      const { dealer } = data;
      if (dealer === null) {
        onSavedDealerDataLoaded(dealer);
      } else {
        onSavedDealerDataLoaded({
          assetId: dealer['dealer-id'],
          businessname: dealer['location-name'],
          distance: dealer.distance,
          email: dealer.email,
          phonenumber: dealer['business-phone'],
          recordid: dealer['record-id'],
        });
      }
    });
  }
};

export default {
  init,
};

if (document.querySelector('.where-to-buy')) {
  init();
}
/* eslint-enable no-console */
